export default __webpack_public_path__ + "cd0a4d6f0a904e1ed051017480bb3e16.woff";